var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStats({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 89,
    viewBox: "0 0 102 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.7812,
    cy: 44.5,
    r: 44.5,
    fill: "#FBFCFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.7078 45.7799C65.3546 46.1422 61.5208 49.1168 60.3461 53.5008L58.2833 61.199L79.0829 66.7723L81.1457 59.074C82.3204 54.69 80.4874 50.197 76.8986 47.7066C76.0814 47.1504 75.7052 46.1503 75.9581 45.2064C76.211 44.2625 77.0313 43.6055 78.0227 43.5114C82.3489 43.1643 86.1827 40.1897 87.3574 35.8057L89.0717 29.408L68.2721 23.8348L66.5522 30.2535C65.3775 34.6375 67.2104 39.1304 70.7992 41.6208C71.6165 42.177 71.9927 43.1771 71.7397 44.1211C71.5195 45.0288 70.6937 45.7068 69.7078 45.7799Z",
    fill: "#C7D9FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9744 43.5209C81.8805 43.1961 85.331 40.7934 86.8793 37.1614L66.2944 31.6457C65.7979 35.5595 67.6006 39.3924 70.8266 41.6057C70.96 41.7089 71.1307 41.8445 71.3116 42.0279C72.2004 42.918 72.6435 44.1834 72.5649 45.4213L72.5118 46.3064C72.4965 46.7069 72.7669 47.0717 73.1532 47.1752C73.5396 47.2787 73.9561 47.098 74.1431 46.7435L74.5836 45.8723C75.1289 44.7819 76.1341 43.9496 77.3433 43.6441C77.5972 43.5548 77.8344 43.5284 77.9744 43.5209Z",
    fill: "#DFE5F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0736 59.257L60.274 53.6838L58.4249 60.585L79.2245 66.1582L81.0736 59.257Z",
    fill: "#DFE5F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5036 50.8006L71.9456 50.6511C71.6021 50.559 71.3961 50.2116 71.4861 49.876L71.7783 48.7852C71.8683 48.4496 72.2204 48.2517 72.5638 48.3437L73.1219 48.4932C73.4653 48.5853 73.6713 48.9327 73.5814 49.2683L73.2891 50.3591C73.1992 50.6947 72.8471 50.8926 72.5036 50.8006Z",
    fill: "#DFE5F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8573 53.2129L71.2992 53.0633C70.9557 52.9713 70.7498 52.6238 70.8397 52.2882L70.9858 51.7428C71.0758 51.4072 71.4279 51.2093 71.7713 51.3013L72.3294 51.4509C72.6728 51.5429 72.8788 51.8904 72.7889 52.226L72.6428 52.7714C72.5472 53.1279 72.2007 53.3049 71.8573 53.2129Z",
    fill: "#DFE5F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4677 28.748L67.4142 22.5708C66.5771 22.3465 65.7216 22.7917 65.5136 23.5678C65.3057 24.344 65.824 25.1573 66.6611 25.3816L89.7145 31.5588C90.5517 31.7831 91.4071 31.3378 91.6151 30.5617C91.8016 29.7798 91.3048 28.9723 90.4677 28.748Z",
    fill: "#718FBF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8564 68.351L56.8029 62.1738C55.9658 61.9495 55.4475 61.1362 55.6555 60.3601C55.8635 59.5839 56.719 59.1387 57.5561 59.363L80.6095 65.5402C81.4467 65.7645 81.9649 66.5778 81.757 67.3539C81.5275 68.1243 80.6935 68.5753 79.8564 68.351Z",
    fill: "#718FBF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2987 31.5121C71.2949 32.047 72.1099 29.0054 70.1137 28.4705C68.1174 27.9356 67.3024 30.9772 69.2987 31.5121Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8795 33.7603C69.9527 34.0479 70.3911 32.4118 69.3179 32.1242C68.2232 31.8309 67.7848 33.467 68.8795 33.7603Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 33.8831,
    width: 47,
    height: 45.2631,
    rx: 16,
    transform: "rotate(-15 0 33.8831)",
    fill: "#508AF2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2945 42.598L27.1351 43.2526L24.6278 46.1967L25.2583 48.2766L27.621 45.5165L27.6944 45.4943L30.8225 55.814L33.092 55.126L29.2945 42.598Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.b17687e8b07cc6a7b98439cdfaae5dee.svg";
export { ForwardRef as ReactComponent };